import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export type Priority = 'LOW' | 'MEDIUM' | 'HIGH';
export const Priority = {
    LOW: 'LOW' as Priority,
    MEDIUM: 'MEDIUM' as Priority,
    HIGH: 'HIGH' as Priority
};

@Pipe({
    name: 'formatPriorityExclamation'
})
export class FormatPriorityExclamationPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(value: unknown, ...args: unknown[]): SafeHtml {
        const exclamationHtml =
            '<i class="fa-regular fa-2x fa-exclamation"></i>';
        let htmlStr = '';

        if (value === Priority.LOW) {
            htmlStr = exclamationHtml;
        } else if (value === Priority.MEDIUM) {
            htmlStr = exclamationHtml + exclamationHtml;
        } else if (value === Priority.HIGH) {
            htmlStr = exclamationHtml + exclamationHtml + exclamationHtml;
        }

        return this.sanitizer.bypassSecurityTrustHtml(htmlStr);
    }
}
